import { TKV2_ORDER_ATTACHMENT_API, Tkv2PostCompsResponse } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import {
  PostTkv2CompsAPIError,
  PostTkv2CompsAPIVariables,
  fetchPostTkv2CompsAPI,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_ATTACHMENT_API.COMPS.POST;

export const usePostTkv2CompsAPI = (
  options?: Omit<
    UseMutationOptions<Tkv2PostCompsResponse, PostTkv2CompsAPIError, PostTkv2CompsAPIVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Tkv2PostCompsResponse, PostTkv2CompsAPIError, PostTkv2CompsAPIVariables>({
    mutationFn: (variables: PostTkv2CompsAPIVariables) =>
      fetchPostTkv2CompsAPI({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
